import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import { Alert, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import useApiHook from "../../hooks/useApiHook";
import { useRenameFileModal } from "../../store/modal-context";
import ResponsiveDialog from "../_atoms/ResponsiveDialog";
import cancelButtonSx from "../../styles/cancelButtonSx";

const RenameFileDialog = () => {
    const { isOpen, closeModal, payload } = useRenameFileModal();
    const { response, makeRequest, loading, error } = useApiHook();
    const [fileName, setFileName] = useState("");
    const [submitRequested, setSubmitRequested] = useState(false);

    useEffect(() => {
        if (!isOpen) {
            return;
        }

        setFileName(payload?.fileName || "");
        setSubmitRequested(false);
    }, [isOpen, payload?.fileName]);

    useEffect(() => {
        if (!isOpen || !submitRequested || !response || response.state !== 'success') {
            return;
        }

        if (payload?.onSuccess) {
            payload.onSuccess(response.data);
        }

        setSubmitRequested(false);
        closeModal();
    }, [closeModal, isOpen, payload, response, submitRequested]);

    const onConfirmHandler = () => {
        const trimmedFileName = fileName.trim();
        if (!trimmedFileName || !payload?.fileId) {
            return;
        }

        setSubmitRequested(true);
        makeRequest('/file/rename', 'post', {
            fileId: payload.fileId,
            name: trimmedFileName
        });
    };

    return (
        <ResponsiveDialog
            minWidth="unset"
            minHeight="unset"
            title={(
                <Stack direction="row" alignItems="center" spacing={1}>
                    <DriveFileRenameOutlineIcon fontSize="large" />
                    <Typography variant="h5">Rinomina file</Typography>
                </Stack>
            )}
            isOpen={isOpen}
            onClose={closeModal}
            actions={(
                <>
                    <Button
                        size="large"
                        variant="contained"
                        onClick={onConfirmHandler}
                        disabled={loading || !fileName.trim()}
                    >
                        Rinomina
                    </Button>
                    <Button size="large" variant="outlined" onClick={closeModal} sx={cancelButtonSx}>
                        Annulla
                    </Button>
                </>
            )}
        >
            <Stack width="100%" spacing={2}>
                <Typography width="100%" textAlign="left" variant="body2" sx={{ opacity: 0.65 }}>
                    Inserisci il nuovo nome del file.
                </Typography>
                {error && (
                    <Alert severity="error">
                        Impossibile rinominare il file. Riprova.
                    </Alert>
                )}
                <TextField
                    autoFocus
                    fullWidth
                    label="Nome file"
                    value={fileName}
                    onChange={(event) => setFileName(event.target.value)}
                />
            </Stack>
        </ResponsiveDialog>
    );
};

export default RenameFileDialog;
